/*
 * File: Learn.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:21 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 10:55 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Constants
import { mediumBreakpoint, tabBarBreakpoint } from '../../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled.div`
	height: 100%;
	width: 100%;
	padding: 20px 0px 50px 0px;
	margin: 0 auto;

	@media only screen and (min-width: ${mediumBreakpoint}em) {
		padding: 80px 0px 50px 0px;
	}
`;

export const Header = styled.div`
	display: flex;
	align-items: start;
	flex-direction: column;
	gap: 20px;

	h1 {
		flex-grow: 1;
	}
	button {
		height: 43px;
		width: 100%;
	}
	@media only screen and (min-width: 30em) {
		flex-direction: row;
		align-items: center;

		button {
			width: auto;
		}
	}
`;

export const TagContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;

	span {
		text-align: left;
	}
`;

export const FeatureSection = styled.div`
	padding: 50px 0px 0px;

	h3 {
		margin: 0px 0px 10px;
	}
`;

export const FeedActionBar = styled.div`
	position: relative;
	padding: 0px 0px 6px;
	display: flex;
	gap: 0px;
	margin: 0px 0px 0px -10px;
`;

export const PanelContainer = styled.div`
	display: flex;
	width: 100%;
	gap: 24px;

	.communityPanel {
		display: none !important;

		@media only screen and (min-width: ${tabBarBreakpoint}em) {
			display: block !important;
		}
	}
`;

export const ContentPanel = styled.div`
	flex-grow: 1;
`;

export const SearchWidget = styled.div`
	textarea {
		padding: 0px !important;
		font-weight: 400;
		font-size: 1.3rem !important;
	}
`;

export const TagPlaceholder = styled.div`
	border-radius: 20px !important;
	padding: 8px 18px;
`;

export const AskPrompt = styled.div`
	margin: 20px 0px 15px;
`;

export const SuggestionContainer = styled.div`
	margin: 10px 0px 0px;
`;
